module.exports = __webpack_public_path__ + "static/media/icon-sportsequip.79b51f52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-sportsequip.svg
// module id = 990
// module chunks = 0